import { COUNTRY_US_CODE } from "@common/constants/data";
import { IAddress } from "@common/utils/string/types";

export const DEFAULT_CUSTOMER_ADDRESS: IAddress = {
  street: "",
  street2: "",
  country: COUNTRY_US_CODE,
  city: "",
  region: "",
  zip: "",
};
